let host = location.host;
let protocol = location.protocol;
let path = 'clic-web/app';
if (/^(localhost(:\d+)?|(drop\.)\.studiogt\.com\.br)$/.test(host)) {
    host = 'www.vilarica.com.br';
    protocol = 'https:'
}

if (/^(www\.)?(saoluiz\.imb\.br)$/igm.test(host)) {
    path = 'sao-luis-web/app';
}

path = 'area-do-cliente/api/site';

export { host, protocol, path };
//export const api_endpoint = `${protocol}//${host}/${path}/proxy2.php`;
export const api_endpoint = `https://${host}/${path}`;
export const app_endpoint = `https://${host}/${path}`;
